import { Modal } from '@mantine/core';
import classNames from 'classnames';

import { FilledButton, OutlinedButton } from '../Button/Button';
import classes from './CustomModal.module.css';

type CustomModalProps = {
   title: string;
   description: string;
   opened: boolean;
   closeHandler: () => void;
   clickFirstBtnHandler: () => void;
   clickSecondBtnHandler: () => void;
   firstBtnContent: string;
   secondBtnContent: string;
   firstBtnClassName?: string;
   secondBtnClassName?: string;
};

const CustomModal = ({
   title,
   description,
   opened,
   closeHandler,
   clickFirstBtnHandler,
   clickSecondBtnHandler,
   firstBtnContent,
   secondBtnContent,
   firstBtnClassName,
   secondBtnClassName,
}: CustomModalProps) => {
   const onSubmitHandler = () => {
      clickSecondBtnHandler();
      closeHandler();
   };

   return (
      <Modal
         className={classes.modalContainer}
         centered
         size={327}
         overlayOpacity={0.45}
         opened={opened}
         onClose={closeHandler}
      >
         <div className={classes.modalContent}>
            <h4>{title}</h4>
            <p>{description}</p>
            <FilledButton
               type="button"
               onClick={clickFirstBtnHandler}
               content={firstBtnContent}
               className={classNames(classes.button, classes.filledBtn, firstBtnClassName)}
            />
            <OutlinedButton
               type="button"
               onClick={onSubmitHandler}
               content={secondBtnContent}
               className={classNames(classes.button, classes.outlinedBtn, secondBtnClassName)}
            />
         </div>
      </Modal>
   );
};

export default CustomModal;
